// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"x5-z"};